<template>
  <g transform="translate(39 -23)">
    <path
      d="M0,0H24V24H0Z"
      transform="translate(-39 23)"
      fill="none"
      opacity="0.87"
    />
    <g transform="translate(-36 27.5)">
      <g transform="translate(3.897)">
        <rect
          width="13.913"
          height="2.923"
          rx="0.3"
          transform="translate(0 10.588)"
          fill="#49d3d3"
        />
        <rect
          width="13.913"
          height="2.923"
          rx="0.3"
          transform="translate(0 5.294)"
          fill="#49d3d3"
        />
        <rect
          width="13.913"
          height="2.923"
          rx="0.3"
          fill="#49d3d3"
        />
      </g>
      <rect
        width="2.923"
        height="2.923"
        rx="0.3"
        fill="#37baba"
      />
      <rect
        width="2.923"
        height="2.923"
        rx="0.3"
        transform="translate(0 5.248)"
        fill="#37baba"
      />
      <rect
        width="2.923"
        height="2.923"
        rx="0.3"
        transform="translate(0 10.496)"
        fill="#37baba"
      />
    </g>
  </g>
</template>
